export enum AppTypeEnum {
  LEGACY = "legacy",
  EVAL = "eval",
  SAFETY_PORTAL = "safety_portal",
  APP = "app",
}

export enum SelfServeSpecialty {
  UNKNOWN = 0,
  COLONOSCOPY,
  UROLOGY,
  OTHER,
}

export enum SeverityEnum {
  SEVERITY_HIGHEST = "severity_highest",
  SEVERITY_HIGH = "severity_high",
  SEVERITY_MEDIUM = "severity_medium",
  SEVERITY_LOW = "severity_low",
  SEVERITY_GOOD = "severity_good",
}

export enum SentimentEnum {
  SENTIMENT_BAD = "setiment_bad",
  SENTIMENT_MEDIUM = "setiment_medium",
  SENTIMENT_NEUTRAL = "setiment_neutral",
  SENTIMENT_GOOD = "setiment_good",
}
